import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { useCloseEventHandler } from './useCloseEventHandler';
import { RCCloseButton } from '../rc/RCCloseButton';

interface IProps {
  trigger: any;
  children: React.ReactNode;
  footerButtonText: string;
  open?: boolean;
  title?: string;
  subtitle?: string;
}

export default function DismissibleSidebar({
  trigger,
  children,
  open = false,
  title = '',
  subtitle = null,
  footerButtonText = '',
}: IProps) {

  const sidebarRef = React.useRef<HTMLInputElement>();
  const [isOpen, toggleIsOpen] = React.useState(open);
  const closeHandler = React.useCallback(() => { toggleIsOpen(false); }, []);

  useCloseEventHandler({ isOpen, ref: sidebarRef, handler: closeHandler });

  const classes = classNames(
    'dismissible-sidebar',
    { 'dismissible-sidebar--open': isOpen },
  );

  return (
    <>
      {React.cloneElement(
        trigger,
        { onClick: () => toggleIsOpen(!isOpen) },
      )}
      <section className={classes}>
        <div className="dismissible-sidebar__underlay" />
        <div
          className="dismissible-sidebar__wrapper"
          ref={sidebarRef}
        >
          <div className="dismissible-sidebar__header">
            <div>
              <h2 className="dismissible-sidebar__title">{title}</h2>
              <p className="dismissible-sidebar__subtitle">{subtitle}</p>
              <div className="dismissible-sidebar__close">
                <RCCloseButton
                  onClick={closeHandler}
                  aria-label={I18n.t('commons.dismissibleSidebar.close')}
                />
              </div>
            </div>
          </div>
          <div className="dismissible-sidebar__content">
            {children}
          </div>
          <div className="dismissible-sidebar__footer">
            <button
              className="button button--primary width-100"
              onClick={() => toggleIsOpen(false)}
              type="button"
            >
              {footerButtonText}
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
